<template>
  <div id="datatable" class="table_wrapper" :class="[propsObj.itemLabel && reportFilterObj && Object.keys(reportFilterObj).length ? 'four-lines-header' : !propsObj.itemLabel && (!reportFilterObj || (reportFilterObj && !Object.keys(reportFilterObj).length)) ? 'two-lines-header' : '']">
        <div class="reportdetails table_view_details" v-if="!customDates">
          <!-- <h3 class="body-2" v-if="$root.CurrentBusiness">{{$root.CurrentBusiness.BusinessName}}</h3> -->
          <!-- <h3 class="body-2" v-if="$root.CurrentBusiness">{{propsObj.reportTitle}}</h3> -->
          <v-card flat>
            <v-card-text class="pt-4 pb-4">
              <!-- <p class="mb-0" v-if="propsObj.itemLabel">
                <span>{{propsObj.itemLabel}}</span>: <span>{{propsObj.itemName}}</span>
              </p> -->

              <p class="cursor-pointer mb-0">
                <span @click="openDialogCustomDates" v-if="propsObj.periodLabel == 'Period'">
                    <span>{{propsObj.periodLabel}}</span>: 
                    <span>{{propsObj.startDate | moment("DD-MMM-YYYY")}}</span> 
                    <span> To </span> 
                    <span>{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span>
                  </span>

                  <span @click="openDatePicker('end', propsObj.endDate)" v-else>
                    <span>{{propsObj.periodLabel}}</span>: 
                    <span>{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span>
                  </span>
              </p>

              <p class="mb-0" v-if="reportFilterObj && Object.keys(reportFilterObj).length">
                <span v-for="(filter, key, index) in reportFilterObj" :key="index">
                  <span>{{filter.name}}</span>: {{filter.value}}{{index!=Object.keys(reportFilterObj).length-1 ? ', ': ''}}
                </span>
              </p>

              <v-menu v-if="propsObj.periodLabel == 'Period'">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small outlined capitalize v-bind="attrs" v-on="on" style="position:absolute;right:16px;top:0px;bottom:0;margin:auto">
                    {{propsObj.selectedPeriod}}&nbsp;<v-icon right>date_range</v-icon>
                  </v-btn>
                </template>
                  <v-list class="pa-0">
                    <v-list-item v-for="(item, index) in periods" :key="index" @click="selectPeriod(item.value)">
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
              </v-menu>
            </v-card-text>
          </v-card>
          
        </div>

        <v-divider></v-divider>

        <!-- {{fn_getHeaders}} -->
        
          <div v-if="propsObj.reportData" style="overflow: auto;" :style="{'height':tableHeight ? tableHeight : 'auto'}" :class="{'fixed-width-table': propsObj.columns.length == 2 || propsObj.columns.length == 3, 'two-column': propsObj.columns.length == 2, 'three-column': propsObj.columns.length == 3}">

            <div class="table" full-width>

              <!-- header -->
              <div class="table_row dark-grey-back" style="position: sticky;top: 0;">
                  <div class="table_col" v-for="(item, index) in propsObj.reportData.headerRow" :key="index" :class="{'right-align': item.type=='number'}">
                    <strong>{{item.headerName ? item.headerName : ''}}</strong>
                    <!-- <template v-if="$route.params.reportId==201">
                     <strong> {{ item.headerName == 'To Receive' ? $root.fn_getDebitLabel() : item.headerName == 'To Pay' ? $root.fn_getCreditLabel() : item.headerName }}</strong>
                    </template>
                    <template v-else>
                      <strong>{{ item.headerName ? item.headerName : '' }}</strong>
                    </template> -->
                  </div>
              </div>

              <!-- body -->
              <div class="table_row body cursor-pointer" v-ripple v-for="(item, index) in propsObj.reportData.detailRows" @click="fn_getDetails($event, item)" :key="index">
                  <div class="table_col" v-for="(col, colIndex) in propsObj.columns" :key="colIndex" :class="{'right-align': typeof(item.cols[col])=='number'}">
                    <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'" :class="fn_getCustomDateClass(item)">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span>
                    <!-- <span :class="{'font-medium': ($route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901) && item.accountGroupId}" v-else-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                    <span :class="{'font-medium': ($route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901) && item.accountGroupId || item.mainRow}" v-else>{{item.cols[col] ? item.cols[col] : ''}}</span> -->
                    <span :class="{'font-medium': fn_makeRowsColsStrong(item, col)}" v-else-if="$route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901">
                      <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                      <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                    </span>

                    <span :class="{'font-medium':item.mainRow}" v-else>
                      <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                      
                      <span v-else-if="$route.params.reportId==109">
                        <template v-if="col == 'expiredIn'">
                          {{item.cols[col] > 0 ? item.cols[col] : ''}}
                        </template>
                        <template v-else>
                          {{item.cols[col] ? item.cols[col] : ''}}
                        </template>
                      </span>
                      
                      <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                    </span>
                    <!-- <span :class="{'font-medium': fn_makeRowsColsStrong(item)}" v-else-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                    <span :class="{'font-medium': ($route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901) && item.accountGroupId || item.mainRow}" v-else>{{item.cols[col] ? item.cols[col] : ''}}</span> -->
                  </div>
              </div>

              <!-- footer -->
              <div class="table_row" style="position:sticky;bottom: -2px;background: #fff;" v-if="propsObj.reportData.footerRow">
                  <div class="table_col" v-for="(col, index) in propsObj.columns" :key="index" 
                  :class="{'right-align': typeof(propsObj.reportData.footerRow[col])=='number'}">
                    <strong>
                        <span v-if="typeof(propsObj.reportData.footerRow[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : ''}}</span>
                        <span v-else>{{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}</span>
                        <!-- <span v-else>
                          <template v-if="$route.params.reportId==201">
                            {{ propsObj.reportData.footerRow[col] == 'To Receive' ? $root.fn_getDebitLabel() : propsObj.reportData.footerRow[col] == 'To Pay' ? $root.fn_getCreditLabel() : propsObj.reportData.footerRow[col] }}
                          </template>
                          <template v-else>
                            {{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}
                          </template>
                        </span> -->
                    </strong>
                  </div>
              </div>
            </div>            
        
            <!-- <div class="header" id="tableHeader" style="position: sticky;top: 0;">
                <div class="table" full-width>
                    <div class="table_row">
                        <div class="table_col" v-for="(item, index) in propsObj.reportData.headerRow" :key="index" :class="{'right-align': item.type=='number'}">{{item.headerName ? item.headerName : ''}}</div>
                    </div>
                </div>
            </div>

            <div class="body" id="tableBody" v-if="propsObj.reportData && propsObj.reportData.detailRows" :class="{'three-row-card':propsObj.reportData.summaryRows && propsObj.reportData.summaryRows.length==3}">
                <div class="table" full-width>
                  <div class="table_row" v-for="(item, index) in propsObj.reportData.detailRows" @click="fn_getDetails(item)" :key="index">
                      <div class="table_col" v-for="(col, colIndex) in propsObj.columns" :key="colIndex" :class="{'right-align': typeof(item.cols[col])=='number'}">
                        <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span>
                        <span :class="{'font-medium': ($route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901) && item.accountGroupId || item.mainRow}" v-else>{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                      </div>
                  </div>
                </div>
            </div>

            <div class="footer" id="tableFooter" style="position:sticky;bottom: 0;background: #fff;" v-if="propsObj.reportData.footerRow && $route.params.reportId!=501 && $route.params.reportId!=502">
                <div class="table" full-width>
                    <div class="table_row">
                        <div class="table_col" v-for="(col, index) in propsObj.columns" :key="index" 
                        :class="{'right-align': typeof(propsObj.reportData.footerRow[col])=='number'}">
                          <strong>{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : ''}}</strong>
                        </div>
                    </div>
                </div>
            </div> -->

          </div>

          <!-- <v-data-table :headers="fn_getHeaders()" :items="desserts" :items-per-page="10" class="elevation-1" fixed-header height="300px" calculate-widths>
            <template v-slot:footer="{ widths }">
              <table :style="{ width: 'calc(100% - 16px)' }">
                <tr>
                  <td v-for="(header, i) in headers" :style="{ width: `${widths[i]}px` }">
                    {{ header.text }}
                  </td>
                </tr>
              </table>
            </template>
          </v-data-table> -->

          <!-- {{propsObj.reportData.detailRows}} -->

          <!-- <template>
            <v-data-table
              :headers="fn_getHeaders"
              :items="testdata"
              class="elevation-1"
              fixed-header
              :height="fn_tableHeight+'px'"
              calculate-widths
              hide-actions
            >
              :<v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
              <template v-slot:item="{item}">
                <tr>
                  <td>{{ item.cols.productName }}</td>
                  <td>{{ item.cols.categoryName }}</td>
                  <td>{{ item.cols.brand }}</td>
                  <td>{{ item.cols.dqty }}</td>
                  <td>{{ item.cols.unitName }}</td>
                  <td>{{ item.cols.averageRate }}</td>
                  <td>{{ item.cols.value }}</td>
                </tr>
              </template>

              <template v-slot:footer="{ widths }">
                <table>
                  <tr>
                    <td v-for="(header, i) in fn_getHeaders" :key="i" :style="{ width: `${widths[i]}px` }">
                      {{ header.text }}
                    </td>
                  </tr>
                </table>
              </template>
            </v-data-table>
          </template> -->

          <!-- <div class="page-footer mt-4">
            <div class="invoice-footer">
                <div class="branding grey-back">
                    <a href="https://bizopsapp.com/" target="_blank">
                        <div class="branding-box">
                            <div class="dark-opacity-color powered">Powered By</div>
                            <div class="font16 title primary-color">
                                <img class="brand_logo" src="../../../assets/BizOpsApp_Icon_24x24.png" alt="bizops_logo">BizOps App
                            </div>
                        </div>
                    </a>
                </div>
            </div>
          </div> -->

  </div>
</template>

<script>
const transactionForms = require('../../../config.js').configs.transactionForms;
  export default{
    props:['reportId', 'propsObj', 'openDialogAndroid', 'getReportItemDetails', 'openDatePicker', 'reportFilterObj', 'openTransaction', 'openAccountDetails', 'openLinkedAccount', 'getSubReportData', 'periods', 'selectPeriod', 'openDialogCustomDates', 'customDates'],
    data(){
      return{
        tableHeight:null,
        x: 0,
        y: 0,
        testdata:[{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 1", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -40, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" }]
      }
    },
    methods:{

      fn_makeRowsColsStrong: function(item, col){
        if((this.$route.params.reportId == 601 || this.$route.params.reportId == 901) && item.accountGroupId){
          return true;
        }
        else if(this.$route.params.reportId == 602 || this.$route.params.reportId == 603){
          if(!item.linkedAccounts){
            return true;
          }
          else if(item.linkedAccounts && item.linkedAccounts.length == 1){
            if(this.$route.params.reportId == 602){
              if((col == 'purchaseAccountName' || col == 'purchaseAmount') && !item.cols.purchaseAccountId){
                return true;
              }
              else if((col == 'saleAccountName' || col == 'saleAmount') && !item.cols.saleAccountId){
                return true;
              }
              else{
                return false;
              }
            }
            else{
              if((col == 'assetAccountName' || col == 'assetAmount') && !item.cols.assetAccountId){
                return true;
              }
              else if((col == 'liabilityAccountName' || col == 'liabilityAmount') && !item.cols.liabilityAccountId){
                return true;
              }
              else{
                return false;
              }
            }
            
          }
          else{
            return false;
          }
        }
        else{
          return false;
        }
      },

      // fn_getHeaders: function(){
      //   let headers = [];
      //   for(let i in this.propsObj.columns){
      //     let obj = {};
      //     obj.value = this.propsObj.columns[i];
      //     for(let j in this.propsObj.reportData.headerRow){
      //       if(obj.value == this.propsObj.reportData.headerRow[j].value){
      //         obj.text = this.propsObj.reportData.headerRow[j].headerName;
      //         headers.push(obj);
      //         break;
      //       }
      //     }
      //   }
      //   return headers;
      // },

      fn_getTransactionType: function(listId){
        for(let i=0; i<transactionForms.length; i++){
          if(transactionForms[i].id==listId){
            return transactionForms[i].title;
          }
        }
      },

      fn_getDetails: function(event, item, linkedAccount){
        // alert('in');
        // if(this.propsObj.disableClick || this.propsObj.openView){
        //   alert('in');
        //   return;
        // }

        if((this.$route.params.reportId == 302 || this.$route.params.reportId == 402 || this.$route.params.reportId == 503) && item.cols.isGroup){
          return;
        }
        
        this.propsObj.disableClick = true;
        let startDate = this.propsObj.startDate ? this.$moment(new Date(this.propsObj.startDate)).format('YYYY-MM-DD') : null;
        let endDate = this.$moment(new Date(this.propsObj.endDate)).format('YYYY-MM-DD');

        // if(this.propsObj.detailreportId && item.transactionId){
        if((this.$route.params.reportId == 602 || this.$route.params.reportId == 602 || this.$route.params.reportId == 603) && !linkedAccount){
          this.openLinkedAccount(event, item.linkedAccounts);
        }
        else if(this.$route.params.reportId == 201){
          this.getReportItemDetails(event, item.transactionListId, item.transactionId);
          // this.show(event);
        }
        else if(this.$route.params.reportId == 801 || this.$route.params.reportId == 802){
          this.getSubReportData(item.subReportId);
        }
        else if(this.$route.params.reportId == 803){
          this.getSubReportData(item);
        }
        else if(this.propsObj.openView && item.transactionId && item.transactionListId){
          this.openTransaction(item.transactionListId, item.transactionId);
        }
        // else if(this.propsObj.openAccount){
        //   this.openAccountDetails(item.accountId);
        // }
        else if(item.accountId){
          if(this.$route.params.reportId == 302 || this.$route.params.reportId == 402){
            let routereportId = this.$route.params.reportId == 302 ? 301 : 401;
            // removing period from local storage before route update
            localStorage.removeItem('report_period_'+routereportId);
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+routereportId, query:{"isFilter":true, "filterPartyId":item.accountId, "filterPartyName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
          else{
            // removing period from local storage before route update
            localStorage.removeItem('report_period_201');
            // this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+201, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            if(this.$route.params.reportId == 413 || this.$route.params.reportId == 414){
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/201', query:{"isFilter":true, "filtertypeFormName":"Expense", "itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
            else if(this.$route.params.reportId == 504){
              if(!item.cols.isGroup){
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+505, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
              }
            }
            else if(this.$route.params.reportId == 605){
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+604, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
            else{
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+201, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
          }
        }
        else if(item.productId && this.$route.params.reportId != 108 && this.$route.params.reportId != 109){
          // removing period from local storage before route update
          localStorage.removeItem('report_period_101');
          if(this.reportFilterObj.party){
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName, "isFilter":true, "filterPartyId":this.reportFilterObj.party.id, "filterPartyName":this.reportFilterObj.party.value, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
          else{
            if(this.$route.params.reportId == 410){
              // this.$router.push('/masters/inventory/productandservices/items/'+item.productId);
              this.$router.push({path:'/'+this.$root.CurrentBusiness.BusinessID+'/'+this.$route.params.listId+'/product/items/'+item.productId, query:{inventory:0, back:1}});
            }
            else{
              if(this.$route.params.reportId == 105){
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+106, query:{"startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod, "itemId":item.cols.batchId, "itemName":item.cols.batchNumber ? item.productName + '/' + item.cols.batchNumber : item.productName}});  
              }
              else{
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
              }
            }
          }
        }
        else if(this.$route.params.reportId == 412 && item.expenseCategoryId){
          // this.$router.push('/masters/expensecategory/items/'+item.expenseCategoryId);
          this.$router.push({path:'/'+this.$root.CurrentBusiness.BusinessID+'/'+this.$route.params.listId+'/expense_category/items/'+item.expenseCategoryId, query:{back:1}});
        }
        else if((this.$route.params.reportId == 413 || this.$route.params.reportId == 414) && !item.accountId){
          let filterType = this.$route.params.reportId == 413 ? 2 : 3;
          this.$router.push({path:'/'+this.$root.CurrentBusiness.BusinessID+'/expense', query:{"tagId":this.guidWeb(), "transactionTypeId":20005, filterType:filterType, back:1, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
        }

        let self = this;
        setTimeout(function(){
          self.propsObj.disableClick = false;
        },300);
      },

      fn_tableHeight: function(){
        let subheaderHeight = 0;
        let itemSelectionRowHeight = 0;
        if(document.getElementsByClassName("table_view_details") && document.getElementsByClassName("table_view_details")[0]){
          subheaderHeight = document.getElementsByClassName("table_view_details")[0].offsetHeight;
        }

        if(document.getElementById('item_selection_row')){
          itemSelectionRowHeight = document.getElementById('item_selection_row').offsetHeight;
        }
        
        this.tableHeight = 'calc(100vh - 56px - ' + (subheaderHeight + itemSelectionRowHeight) + 'px - 3px)';
      },

      fn_getCustomDateClass: function(item){
        if(this.$route.params.reportId == 109){
          if(Number(item.cols['expiredIn']) <= 0){
            return 'redcolor';
          }
        }
      }

    },
    computed:{
      fn_getHeaders: function(){
        let headers = [];
        for(let i in this.propsObj.columns){
          let obj = {};
          obj.value = this.propsObj.columns[i];
          for(let j in this.propsObj.reportData.headerRow){
            if(obj.value == this.propsObj.reportData.headerRow[j].value){
              obj.text = this.propsObj.reportData.headerRow[j].headerName;
              headers.push(obj);
              break;
            }
          }
        }
        return headers;
      },

      // fn_tableHeight: function(){
      //   let subheaderHeight = 0;
      //   if(document.getElementsByClassName("reportdetails") && document.getElementsByClassName("reportdetails")[0]){
      //     subheaderHeight = document.getElementsByClassName("reportdetails")[0].offsetHeight;
      //   }
      //   return 'calc(100vh - 56px - ' + subheaderHeight + 'px)';
      //   // if(containerHeight && headerHeight && subheaderHeight && tableHeaderHeight){
      //   //   return containerHeight - headerHeight - subheaderHeight - tableHeaderHeight;
      //   // }
      //   // else{
      //   //   return 0;
      //   // }
      // }
    }
  }
</script>